/* eslint-disable sort-keys */

/**
 * Debug it easier in playground:
 *
 * {@link https://microsoft.github.io/monaco-editor/playground.html?source=v0.52.2#XQAAAAJfeQAAAAAAAABBqQkHQ5NjdMjwa-jY7SIQ9S7DNlzs5W-mwj0fe1ZCDRFc9ws9XQE0SJE1jc2VKxhaLFIw9vEWSxW3ysc1TIb9AaYy2oqs5okEJw0S0WXEz0p6ZwIBUdFl8NjWawaOm4b8VPZoiFpexcYzmeau93p64NtUiaZqm5POJifV4iVeMsAcw7umel9qYM6Jq9r64kxz2KmJ1Via4Xeqgb8uFOdFvf0j_cg-tZg-ujV0Y2Oi24m6VrV_QFkXOQvUQ7dlG9oMP-GJi3prQBjk95jyI9b_2jVYr726Bb2Je3AP_9PQV93nGm0rvHWeb6sxz9bjnjRg13P4ycyvEhe4-xiGkW3otLgXjNrEN2sWFDYluHmWaBOrOBLJklBT3Y-G8GLEafYuhesa7Et1ta-dKE_yyNWLF4R2nDQq_8ZEkVhM8X5RsNoJejC_AdFwgjLDiMBRl8SD4JZ9A1op3jVDWb0Gq_D2-06eqQBdgSRaqntxTOT-rCY1oWK5La0FXs6b5kW2Pa08Oe9Cpu1VmeOai8rRQiBAoHb2oUHFdbvNRqxXn67tugX2lrpT9Fe0iR1a8L3LP1cOxliKpxImEBvzrfAR6tkFl4F7z60Lr3kttSohlpV6B3_BIOJap_9MThHLVQ1T4vsJU-2vyZKoexJU8OAU9FRZ_Ud1Deo4F_0sr3tEsh3hyfKyndYMBMw-kOAUPFfGDp4xDddGzYmzs8ahOJVLgXM4d9uJdLFmvPPAHvpLKzq-z7_ikyze5rHIHdtENI2mjzT_r6ikUR-NVtJsWMrlCdr_A8Qy-Ni8yFRUXIj4YbHMgMJz_0J_eSUZ1QdI8vEP3hp62DgNLHhXQ8ZuJhRkV0pw8yKKmWUeG3xPmLCxfHNEaXlz6-0CXFo-KrOBOY-wZDse3GA6VZ330K_KEdAzpbyMs9LyEUp9xBp1AR1UIM5KAA5kfjW1plgHgzFTaL9jtnJxmxRbrLy9s_EUVab09zrGD2VttoRAGY3iRXKtTcilEH6cxBxxdnIJTkz_5hu5Og5ktv1gxg3bbVnXHFgDGoeEaVZyYibJGRU80sUfo63sKrVXIS6i2-p_nlEVaTEQI8DPRyAillc_mjtTGCTp5K4ev0E4pmBdFZQjtiMZwTwVGSTaRjiz9MzBTjWtJEmkeyWCx5IZxDtooVYtJHIj3mCuckZdEtSXj92VtCBM0J5zhLIRd4SH751DOOz-QZmjFwWqeSzsnI_6WAmzkwchpRtX8_AfaFM1leeACe7hRN24h9FLmgvENpD7J9owUYBrLVWwX-iGPLq26nbbZvFKu-Ha2DJq8CELgnCE3cizEzIyXrTu5IpWG19IzN2ArYEV_ro6aQRNQtfG9djWzLc4RMCwq2zwINAOkqNNfDZQZIMxhEBgEercN5hr7g-oiM22WYSOPDpycbo-xIYZ34rp-CRpIXZIg48DaQsD8yk-TRE4D9DTUNFibS6f3c2hu2k83KSJRQjsg4RXPRjIuJhelLwg8WkYKqLcv41ZplsuEgBotnTHxaLNbU0PHIIV6FMII25vYMlOX-kHmz-wj4448sB6UvwuWWoSj8S2hjyluo0JwHhqmZG3uccgaXc3cG67hiij4JDP6MtQXo9ON-8r-Y35wNY-5u5oN1KrK4JTuZkh3SuV_NWKqN1XDdbzJOzVNR3onvmIt3L-5BKoWSboUrni0ACromUaN4bvHIZOs12V_R8v18IdJqwDyBgOYQZJE2Fv5xK7RAOmmlMynWC4HYD885NQMk-v68zBJUhs8W4IadL4gYPPm3vsA0IeE5sm9rbpSEtYpCtUYt1ncb7aazuNj0YhLOLoUGkUp_xKLwjUAa7J-bIoDKk_OZbBCptknwF3hZLabkbU7OD770Po_SJr6Q4RRL3aRVV4mm1XDZJeJQIJJ3uH5JssQ2gbF8xRO-6TAMycFJKIdkfmUJR_m5qX9mjr_hyf-ubnZ25vhuR0rezAlg6xKQH7Ic_DdFXoo7JndfRSaGGJ3Pckg46FMaerw9iK3qVl4MMErN2KYV4USF8v3aaOu0vhSgZHcsi16abcDtL7GOZr_hs80w5kmcZHKfJ9FM9vpkf3U3OBkF-6eqif2C7iq9A1QSaxMRdeOYv0KkSqmVyoaf8bY2PAQ93Xh-BXIiqJVVi1c6y05vYDVaYe-ziGi4NctPY7QgcrmlAPusTw3uXV2u3nbbYlpjCE0fUoLlBNqcjMPB1-oyatEE1S_6iZHdY1sA4iHno9dWBeuR4JR-pNDxRRAMmiYcxUqattE5WBnlQmH_GRLCFGbAGAEKYW9wDSqUpTIFZ-5eGPu3sjYPjadT5TnvJR7o1Vq0ptOl9gkHFznL52AUeDXzcOo2Hln6njav568vsoPoZQcIoZUysl9r0NXOV84nXbFiZttg4GOSeRSAtuMPtkFGfnQkwYV7SMuH0KfpqgjUNhNkqVYcEnjwMUVDhpBvpQE0Fvk275p3bDcu5rA4h2iU-Pf-aFN6ne7TPZVX7QjNQKqz7MEJdv9NCpWtammBXgMxQMssWAs9mKeNuxYfGu2dGF-FtKDq5ziI2qzVxR9A23Izb3uo7iyTRLGUKxMOXKGRESzBt9qK1_OfULtdTZDS5nfANehg7TnvWvHQ1KRZI1Kn4oBIK_boxYHuZc1w6mPq82E8EV27Ng9mFd-vYb0G7RUCc94hG6xFqMypXMpis3aZKe3LlblCKuHQhjHouyF2BLDvCHqYkQiovAteDI6hT-0naTIgyq7tdTNSjKo-7ndIWW5YJAL0435v9TlMFbgoIJGHHI1i9Oz8TNsJq-Yf3cWkUs5u5RG9yzm8K4K3Xl_NSpBo7Vb46nj3RMeBbOgwqiAd3cqBSeTps6wCFpDSFhGsUrSK_Jg6GJBjqGC4Cs0Ne0yWJTMABwJRkWwSx64BtAdj4AftbrpeDlq5v3YskoO6BTN8Tq4-ZH2t7EUvFuvgY4lI6epXsQLXNg6muAC1kz4GWJ3-7cm3cUJfYRFvyLVOFGOHOSM9_7FTk0f7oTr0FTqifjZk9RZ0HHSKCXWYRS8q2Nv0tTAJMf7FCpCaD8LpwRsIYb4pVYl6FMUl-P2ak3Dcy-x3H4sCv47RjjZD0nMqqhFgS5dscBsFukWfaoyfgjPZ0p8gleG2V3YJPPiZ7C8ZHdHYhJTvD8P5rnYTKVNurTtRC3LMSs4JXpTGo0zIv2FKrkldt92n3ihaKX62BERSs__S7giqP8CDAay1AUSY1Fn-zuESmTtz6CCxYVoZmD6ir8NFznPQRJwK1GVk2GRV3xkJ0an02Ttsi-zwfiwl7NC8lJR9ziGKeTNdSkBm7suY84s0x2YNNQ5WSKjzfrdfnvkj69yaGvzAxk_j_XrwaX34hmCRQYLkVGTBD8QQtl3-xdtrcc3ufHKRRvq0kr1z5aW-4qnFiIrkLeNPKOpk9mOJ1TrejmKBsruZsb5dFtoa0Hm_YLSCuIxz9LAqVkEymF2lE7Bg3PCwmdR8irE2704-wIH8xucIk-Sh7JHjEOn5TigW1YMl_i6BpdMCn37IbidF2BekKJiqd4Gfa67qWwpLg7ALvQju9X0yQZLcT0Xu63SiOOClS3m9Gm9J1nOrIeauETL7YFwmPdJHt4Ik3-zi3Mc5off2Pua9umtXnO_PNw1OtG41Cht9VMR42MidgNSMY-elcgyC3H-QXHJs6F1egpMhcViCwL1KgM3-e-7Ri-HhqANI5j3J6J3sy7ytzy1sG_tJxrrwvOdgaSaEKfWmr9iH8p2tDPGt_5OfwMdJmAL1MpNEGvzv1agyIF6scCc_Qzp5nRXRNRsJlR0D5L_OGbSinryynWrp55fBK38SHv4P19LIWXooKNpiEKVNp1XSXZUsWqDWTcL3Gzev9cOE-1rM7dt2_5ozKVHziPJr6X9-1KWrdK-5_DwmNk7XIfzfUsQ8_SG76kQAPHXlE1HesgO3dBvFRoSRUInlpqI4B0iXT7Qd2G3a5uMED03_SVbdYv2Ka39kTl5mKIpy4U9xqbXyOp4A-PNfPRlyg6C0FZSiymAG8sik-F3f7jqK6ri20mag2lDhIIWA4wK_-4b0aCtDNH_wjeb6KFnliowyx8pFDyg4EtMeOEyTX8LkfSZqvg6iU9Q68rLBbAcKXoJpOMe4v-XCrQi1dDvQMzQQPYMoHDiChwdcc4oBXNagoBain2Z33bd0hhdQkXyJID944F2QXH6eFHhnDYY6is_PYj_4uDx5lnjUkEj1Tp4dSPJjGfXve4jP1AfySv43IS0_SwDGSFNka8o_NwLh8bEAfIUFtktJOTtz_uOOxgbMfJ7RPr-2bV0YOeHbJhSqSAwLQ-1u4-f3QizZAVpEiX1mlJmDBO5Hx9qPhT-m0Qijhr-dd6lOoPcpSpRZq73iG5NzwNGe6-fZ_Bcdlr5NZMl6pVJWGvNNQ_2J_Dot0GI65CPMpZoUSaMCc3bjvBKvf_JI7MEJAENXGA0ACrwbX3RVcnrb2REQBij85o2Qwum8CmgjSVitkUYfAoePb3jeFRLv7fFwU_6n9hqj_NcQSZLnA0f9X1yjQKpNRK6jmGn5F4lJ9pUJ8V6UH0TVF9wGRPgFILh_i8L31cslc1jEJfph7YACgahbWmAS2sy97CPOiWyadzp-65MfKakwe9MK4Sm5YBXuUFsy4U2xaOdPYUC9qjIB8X9l-J-psemBvnJo57s8T1bIU56j-8tBpje8xTlfo6NW9vDodqMVlh1u8cy_us1rQA6WFuXjAhdvIw8pvkJ3oIpCPmIOUQ1R1kUc7pqcuKcyOybqdYGBweLSTfSUrr2R8xICF_69na4QFNLGLw7MwoW5HIlt1ZX2GWOMg0ha1vgJml716UcXAcWPiLRYsQoufPJ6zqIRU-6AFU-pozqo5bb6XitOfPQTcEHS61NAw9xiq63mW6wdg6DPgbp1U9r3dal34OOOToNdqwuXo7z11TyJNklbDZ979JEdDuJmNLzlfcWQHyVAh7z6bipklvsCboBQB83bfAvxmj4tZtS0jXfOL5EME6494ZzSEDFdWmeRJJ12MQtwPZe-6szSMufG1u2S9MfQX8k0_e71NDp5qLGMqsa7d15fL7_SlqvAjIkXAQke89OcaEiT2OlyKd5DHRFRWJs3ghW6qX9HguhiRvvKSoqSa9XanC3DMfvRF2ab_hbpnMSnKJi_AWEgkXifv4vp3qaUpV_rWUWmRZbGTBvJ7HedSSjTE88ZsitM2aRm1HLIzl3rbKcg9xDDANoAqeOwVKzIVgfZaRFV__TfUXlUscspcDtIw-RN0Xx5EJ5FiQaGc1uIwdj5v6MNR7HNuPJizP7UFgowaxdL_z94SrJy_-TQS2RTlMvlm3ARi_gbZ2BMCmGSUNx3WsvZ9Qb7II2kgZkOHUsaALvGbmBfpJG2ljDG-QIT2Bd_ZgTIOIQGJqw_MOlXOm9QyQeP8xuwvIzMdJ2xNNabcUihoTgkgvTcYuJokWO8rhs7QAbF0cujzrIOPa_LKhsfxZrmdh2wEgBSoOLn_yTAdianoxrTgbXunE1YrMzGPWHn024MTcLLul2V_ux5RMU84EGXfZzpGzH_VD57N0Gm9MYPX9gTALhp1JFyNC0M3nAlt1V9kpR3kJ7egTL-El7pdJt8lyp06sr3fhkvSHhaUBEf_1Ed2NihDMQHDhVbnpMa3N67dDN4zu7DkBPSDs6vWlmyWK2vFfLnhO0pIBboMCn1HVvtonK1r_o57NQQ8_9nncptxhuDBLYXKJNcOCwRINuJa1GF0Yz5F-cFeR153M8DZiv-n9PuEdZWYDM9TJxioKhIli5j3rHS6ZJPT5ZfGZjTizLFGBCF-zTg9ixgVS_meh7oBdLYG9DFPax49thvOoKqqICP8CboiSPYZD2vKaYkkQS4R0CqJLdHESGoctdlG5631xPakd1gheSNOCv5dQGa0nUQbBC2xLO3YYdCxVwm1di2CTkmaUxHOqUcM0ywD5FOOSX5SAmFeHwnmP9ntD1SO3R4D9aGw9G-EImbf_2FEYYhn0qM--UChMfe7rMybc4ylW3PJsejfFiWytXSM_zYSjglrDjLTEK9olZnUM5bMyMYgLQ7nIgX_8evR_WtivkBfNoSjGZNbuVaBDtmq670lZq-WW-bxFhAL5qHvmxYZyxF1GRoxE6wlhQXmgolpxb6a0eCpyHMCFNbRHYPG1QlNzpW3RjRAgK4JhXPRUXNhC6UI2RLUjCOEVpeTFjTVJ3IfTrX9FILS6c866ndj4YW2TEdjOkmTftWOBbtLt0m0VjHPGL_-MrH96}
 * TODO: idea on how to solve commas
 * {@link https://microsoft.github.io/monaco-editor/playground.html?source=v0.52.2#XQAAAALUgwAAAAAAAABBqQkHQ5NjdMjwa-jY7SIQ9S7DNlzs5W-mwj0fe1ZCDRFc9ws9XQE0SJE1jc2VKxhaLFIw9vEWSxW3ysc1qx8QQLxmPEoIpZDb__yKnCUqfEJ7EsBNibSiQbBpbCax8TBjCZU7fhcCTeJACkrIIUjetb5F1OtjfB7juxPrMNFK1mbEaOG3RMIGU7WlI7LRTrNiFpNZvbukk6wAiWAq8SPFBHqPE1j41xqWdr84AUcKVXPQvswcM-eD7BXYzqSqBSkvLoVlEm3TyqcYBWPhHViBVYr2dqAR5pZGxM_iBwc9Q8FlaGRO8BYaHJhEEDFWd5bf7N6YHbj01mUvcSBgg_pK4SohZT52OZZmoNJK8mUoRftCCU76xXrp5U19sxI7FbekOUHAEfbdzk2g9jf1hjxthAZBFhzDPUuVb2ViyXHl11jqKhqzDyV4OHTIgWsZJgRdBd8oUERLeq1o5eXB-8STHQgkzgw79Dy1A39ZSEkJGlzxXtJphIeHkOy_DfOLFZBKTo6thh2HiBZTorrMmUeeyNlNurc-zwZJbzk91Tci2StGwQEDw4yI0pxeeLUlQyjRObSaMwyD7GcyAOWkO9TlsHYt0CJNKmv7baRWl-EQR3PXxfiIl2b8-czulM64ENo2i73efPiyYI_O1yFMfRgFQwXF2b7D8xD0g7GrXgexSsTQ7u507RZBtBX1LhKYs5nRttMORag2Cnqq72XhvRbT2mBvhpUrTvJYtux0B2hpBdAKV5cN-h8hA0rzjSqtRmIEYEUUu8402SeqqfhKRuQEknxwHe0miKWwG2tRf7ikhRqBScP-6k6uxwJKvyWGjJQf4bi8uHa9GbpHmzQazBP5XHWjuw0smxmcWxJkU_fTamhZj8NNgm0nfRPBnXiYCRj-PrllNLFHz0bQPu9QwhPCR4eGsqz7OrWFmWHAdUmy91CEOE6zM9arD8CNxAGlrQ0XJaDhFhnU7FtH79cwQitm_nJeKDx6kQqeXaEU74gtMplX9q_gwWimZ0gORdSRtCsSJe2clT6u7vfP5-a1KyiZOAiH0CVDShKpsUuHCb-h0gdKy_hK5L53ZgkHGOToCIEAgsXzdSGwAMrUqEMG5koa8sRzCI7wFfnNWwKgNpi3TTth3vod4NQevJ6aFEi9sNmosjx-I_GGE7Sq_NNf72AG2d0IEyePN7THhFEEz3D1PZObhMQoiIYSH2T_VJ-N2411pwFfHeJW99DtNi6cYSIidYcO5XLCZpvHm_ERCvd4c-LHpUdklj14BHZ8V8mIR1IH-Uly-9Ldc4gs23ZxLaVAlSMAL_WL15YVOcI6SJxCczIkmGArbgfFIKXwbqRhT75un-zFFOOa3cVlKnri7o0vlUYEvi_KrkSfHpSHsJSwr7nhLHzkGUGwWtgXfrF-8BAwRnHCqYCzmRAIFO0Q-FaL-zlmOsW1m4zxeMWgXTOyq5J234jSQOxx7Q0CpF2aHbtIokMWI-G0NaHuV7UXlYoJUmtZteKiM6ouInuisoLhqqTTMdvlTYuy3MbKCI_CKBL-ql4pcsxxxsDSiQnofGA6KuEYlJexePg1-1M7-ReXBhtZPAiNycyk6Ob3T98QuHYCHk2gZFaS0rGMxuNtl3tDCF8WUQhOpN5oZYmGpv153CEs2vQbwHzN74zoJa-Py2ReRNqe3DN4gjIxLtnlu_b3VI_6vjHDLYwnok8GKKzBkSH3eCN8LFkibLgLoksECHVl7kD13YVVpotL4z8ett2pixXwhAMXtQTejLVfmlkih65Z_0MZWbjjtSHUYJOaBmcga_7SNur2_Suy63TvgizuwX8ch2Vdi_kmc0mchcGPEVa4gPWe6mey18YfepVDI_QQrW592yHhbQ8oK8xgYZspKUrd1DUSRuNLTuWwEw-7rOdClTbKV2DbO4cAT888Rq7Fk7-MruI3gEzVWEMhT5onmkiR17iLum0msydt0xaYCc34OhvIOgUyWNKbYeXlpj4tyw0CsS5JQ6cfhCN4Mu0-KznPuIao_iMGaee0jDvVFSziw1FuhVhm50ENU-8VBWQPSmIZJflK2o9EHH9zPfstLAgtjYVemzcZHbzM6pfronCryO3G6kaCXiBuB6yHrjaiyCXx-oJCokHpxKcaelgYRezU5Xf8_w7SZgT5n-wa-Qp6HQ5jYQ9PrMqwWUyd8gCXkKZ3tz0Hz-YEQR6eavxpsjhLFUNASZ7zNWCGEN79USCE_AhPvGUuqv09hy44B0hn5lLDBMkdyLhe-EHAlaKrxS_Ur82FBZOxba9vdyVTQOhaPbOG0uL4ksWw2m59z-CfSyPpAanY80U15Bi8M8tAaVXeC_yFeyvUWgx7mzKtVnKfL06D_NnV4BdHBWurpJmlPFjxIrH8amAU962UppqrtEa-NWxujBwARCoj5FkVFeZAekG8RnO-dBjnlyviknWBBMPp2Z5mtd9CNACwxyT_b--mv8DF7BxWxaa6RsyQdpXfWfJEdjoLoyp2t86K7j7cKM09x7odWBW5rUaWYwAr8dMneuiZH7E62oo5Krwk8ebex_58xB_nMtwzsbcsQ54pw5sDf2VZEHmZz1q3WRmXpZBwCKQv81rwluYbTeldBkBY1u1H60u4UUlWCkCSUGUMFnT7awy8H78FO6aAwS7EOxZdBzTx0pOBhBRUForg7WyTR5iRnyu3E-Bx4iMXQvVeiBTfeaUXgInLd6SPgysg2zvbQX9Fq2SouLNDfxMGEPxa_oOI4ALP0d3tkXVrb2EunVdreACb9n4o3w8RPwd46XhXTVYUOf_nT7jrvP3sxxi6XpITqvNUVXmIJOpwuW7BN23RGFmedfaajUxfZYjGzvYIO3geZORVPhEpe09eHXSZzTp_ofv65EHfLd9d9PoVjMQrVjY4WkT2auihOxc4YHA7l-p7LSH1v-DPOe1dSPQw2qxB7LpBQ8Uu1oIYRcj7S8eRniNDWWe6-b80We5kiXHRdl8VBdh_aBoVew-1IHc-zUi3N6sjocO5Vm_kzYAxw72DBzEwTFsk5OU8tuEf3LwxqLV8kTRZmaztOqJn6Ky0Z_epYX1oTzGWRWT6lKTgsOfsU76DCRSeTEgKJFkwG48qZ67jmpvhlIw5WbCSDTJCwYOwJI71bzw6VqBkhqRurvTzVNlVbRs_tQccyJFDWRALAhM_At3hoRw2GFU1botwXnM3tVYJ4ePFFcC6z9h1UrwYuVk2lNCVQJkjTby6JQ4CT4Ud2ySbdvy3rNHIP6_fadE4aQ5MsOVTARRUzKVgDM4B5VR5dr3s7hllJeuNldUwUiAP9Y1RiNJiV7NN21kiul3Ecm64QSGKUfuVnMGFlpsmve9oC81ua1e7Y1xM9xid-C5-WMgucCLzDATRnMJnZohu2lF3bP96_VZG--ChDrN1uO9XgyASdZLcAe0If7ADD-d5gpkkDHui3c3zOs9_vvI6ncSrjmp-NL6CeJ8j-Wy_vZ5Ehef6UJGRE-hg5Pc2-oj8aeAvPhS1pHuVQU-5pCf0-7gbeZKoTS6m0uajI-R8njIeGc3LIbrozcnnU5J-07WnLut7eAC2piqfK6UXE74v7eArCU4vPLDyJCKGwgJi7P0RmSfap53_1j72R-FkV3dtzu1DjXkQ00r0NtXhYwDUyw_FnV_4VnmDHpvOUkc677sSS66R34NIQegyOnIcgMPlibtF_PGfsIolSlMRrbA-xhZMab_hXK3zwomfBbyt4X1-OCthg0o9qQLpfTkv9Kn7j-OukjEDDoQVPteMvds6o9E5J5ziqPeeJmPtJgUIfielKIcy_2tiDA6sihw-BDxsBeInPD7BqYZRKHjpe_0eThV1u7DtC-D6fzwik59DRrJm7ziJBR3Wuk0LepXPIYAUH4l9iDdj3kZzhJQNS9osMTYtx4oZeLKoG0Q1tiV1QM0FlTYuXopTRtWnpjKYA3UZkWAr3BYJCJB9MTKi5_J2Xq0UJJU6FTemL0GNiCEgym7Wh9uLHkNLOErMqBv88QQOa9YvL_BOI1S9feIZGxgZEcKeK3cHoAQVKhBhcZ0lcARhDhsGf87Sji2iTiM3EQDCD8pOBir2uM47HTuBh8ectf1kvJVnQ4Sk9bjpqg9XjO26c-CP8hZJn0ooJuNg1_JCgDPS-D2EMmeo3iexbPillwynOZ7J2OmKnwoKznyUFhvHUq8Hxi9h5_I1jr0RFjYNFysvJkTbsn7sm9yTbp0qLtxlzClXTvpP5Zp6nLusGvoTV3tRcYfOPJlqOgUl6RayUHQbgaqQm9pI-UUmQbwsGLAU-HDTFZljglNKI8soiyYspOjOgwEX0UeDBE0xG3BTQa78mF8ox-2adf624LbS52JtxQcilKri0qHL_JdHpA9qwu9FR3mEgStYnMdJsWH-irnoLgJEACy6F_QLPVa1ODOND8W-KLes2bM-tmt1ZGS3GVnYmla_Kv2ZUgXvsot4mM_WP5ee-jmGBYQvkD_UgVn8_ztk0Jmw5pxriBmtR1-9Qrs7vUCkndp-IZRqLbqhu3Z2Oi8KLUZ6uf81K3ZnHpNqKkkBLke3VSXfBEU3-0C62v1gr1_GNzNxfi4LReGgSyNnIrUHoUCWoCbtMShgEUV6CY8tn3DKO39qlDGLd7zPL7VBMM6Uu2NVK0lYNgF1_s6qyQVOPiFQySAEWisMKZu0BiV2KqgbvRpaJZ9YQPARbbWd32fNqGQAoAifSmG7QjXx63F22J-S6PC3sQF77R3jBJrTumHEdzCjBKBIkjJuEfBQtkuyqc8ZTxwWJ0vBs0-BeWrvXbq9GUdR6MTGhddkmLLHhWWQbNFREQrXXIEAPRWh0dH9lWqAlwsL2JnpB1HGKGCLezKT4fTO0Ty46tlSyrekmUlwfD-DbELcswdWjui1bPvLO3RuTrk5mNW3hCTWsxj-6KhBmLq3RX6LdIIHKIkJrMzlqRQrmouNb53UwbpGJbwQqnA5n7OM9afEhwupUKVSH9LqlxK7aBAF9h4Gznm5Ar90NgTexsErK5PyBTeFdZwWK6TLSKw05a_G3kbfRJbtlm8fUlOe7MeUaUTYgTKQCpmQTzPIfaHYz24QGU0TPl8lgoNcfYlJNy_lG5DjatH_S9EcddphGqyfndYGJ_9FKgY1RjSahDd3XjhEgi4U32YHVMD_Bj4vrSU34snkiLdKJQ1rnp7qGRC06HaEa8v3iXMwEZ3hJDz3IVYjLVAJU8hFK22GhI-9XnczYjpkU71ydmNTmMiu-mk3BPUA9Ehb02zdKaSwoKthLPaG-WCViNLWXFwZCrZOHzm3hGQsBPft04_fW0LbviRoEdu0Y2PytJ3nx01G3yOpRYFzc_zcS_TmBE4_lshM9Yypm_9RGgooIxfB-RkOv7Rtn3ho50IEoL0C1EMQd804n8V7d8oZv20swUao1w0rcF9cDq4Ov7QKoI1e-OXNDHItjXRPG7eYJYhnVX0M-jvoGqh6BXpqWRfK8Exx0MQbT878-5atiAIngX3CA-kdc4D7qleLrIb_VlI8TUzeaaRSNWaEqjaYRll6YW-gvw-h8pi_R0SjRCcBcCkCFCVJEXdv35h3h_0fLnX4hRKV4_Y414g70LHOwFoW5dZnXYovrS5hCA2xI514VGqfy8Bd-1_tNiCxYb13i5U86nFrvj9bXHnqA6id6wXiOKaaSTmZoE_tQAio5T92-NoTMzvmfH0WmHTUiCwqLIIZgq7niEV27XD9BG_4rY-NsScIkO8L4yhKtta9dkG299MBQBJRKpNvCS3XDJd71Bau5tpYfV1x5DD40mbru3CnQG4KDcLa48CEz_3A6rZqWhC0C5swg19xmZPkp2BKA948v_Ty4Nwfn-d_jLtX9aa6ikkJYSxzB-QQt7CIlrL3J0DdnVNzBQ-bDnf3_NLDg7OK5AcbMbScLKDutxc0e_UWnDma6yxLGe0-VMAQ5eT_5Mjd7oWicbtnxihBkmsYyRrmIQIHa1IFFuPecue4Xds8jnEnZcq2JNnjIiJXPHF3UKfQIR7XbyO144TSS5IOq4aVMbwCZWst_7FkA9bHDmD0Bb1QZQs-hu9GO_bMTgqeTA0yVcAG_5JazPc4RWju9nBrrh11hqhoLRkc4yG-zSiTGlOgb7DAg1MmYVtRxeriC7zeKe-uO3NOOfZScM79EpMu6hTXBgQoKPj8xjbNsfG3_DTwb8jQUxJjrTT3MTFd_reQu4TTY1NbkRzOVjYMZ40DkKYJMzQ0DiIOhMUJAzo-2dFwLlQhHSHjExhmX36PetjkZlsbpMtoTYE6rFuicgLbc5TYfzSFKNreTi2pz1lWoVSn3zSUqVygslxbayu9Hn21ABnWRCFxoYiK2N9l0hJdKE9Y5Kugn-ARxcc9YXrkTMg3_EChCg_Pr7JfvlZFsWacHzJJ417G-GzJqtK5aS6ARkuQgKr0PJS8uMB4HILiHtX6MfFEpmAnycP73Ss1l9B3PF5T9ts3aGPJk8ocYHQuWEEZ7iNUNCvFrzCbwkpgZwlJUp4LAjZIh8pgTwrcvUYRm-GTbouQiFp_WtSUX4o-yZL_4t9BgYBdWmZzELgbYzPqy-SRiuMVQMiHxN7D7kofN3H4JyuaHBKZZ0-i_VhQv1z5xrcYm5mnJXr77neYwtYj3dKLlNPdRVyfMZmKvjWHZFsCj2ExwD-Y_V_Z7DTB_kOyroJcGhnlRfVQnI7HEkGMgIKFupqv8DXblM3IoVny7Xxp4VDmJoQOrgIADAZ8PgSoKdjzWPO3lkBBtgOJJVjegD447qBsPFacxRCIt46illxixK3VLFYr6-Ax7Klz7yr-6NCC48IWm-Wq4S4AH-ptxYniVbDnZzTB_Espn8_LfekX45is1SQoZKx1w9KCjzNZLDbmeNFvohDsPZ7ZKneAeuG-GhwDMHCR1aNz9uj72CRdbmtIF0o6QsKP8stjWneohh-5RtLeyuHVrpMEzbS2dV2jixoKbFjyp7cAZR3xrJ8O_vzyqot3beSwp2Tw9T3KBr8YobjkolSB2NTgqWmuywfHT-cEjZndF_57tYocse4X8n33L5Vd_8-TLVw}
 */
export const MONARCH: monaco.languages.IMonarchLanguage = {
  defaultToken: 'invalid',
  tokenizer: {
    root: [[/{/, { token: 'delimiter.bracer', next: 'keywords' }]],
    keywords: [
      // TODO: find a way to enable this, if we do everything according to linter, it won't work as expected
      /* eslint-disable no-useless-escape */
      [/"selection\":/, { token: 'keyword', next: 'inExpression' }],
      [/"filter\":/, { token: 'keyword', next: 'inExpression' }],
      [/"subqueries\":/, { token: 'keyword', next: 'inSubqueries' }],
      [/"variables\":/, { token: 'keyword', next: 'inVariables' }],
      [/"ref":\s/, { token: 'keyword', next: 'inRef' }],
      [/"sort\":/, { token: 'keyword', next: 'inSort' }],
      [/}/, { token: 'delimiter.bracer', next: '@pop' }],
      [
        /"(?:period|target|using)":\s/,
        { token: 'keyword', next: 'inKeywordReference' },
      ],
      /* eslint-enable no-useless-escape */
    ],
    inSort: [[/{/, { token: 'delimiter.bracer', switchTo: 'inSortBody' }]],
    inSortBody: [
      [/"by":\s*/, { token: 'keyword', next: 'inSortBy' }],
      [/"descending":\s*/, { token: 'keyword', next: 'inSortByDirection' }],
      [/}/, { token: 'delimiter.bracer', next: '@pop' }],
    ],
    inSortBy: [
      [/[^\s]/, { token: 'invalid', switchTo: 'inExpression', goBack: 1 }],
    ],
    inSortByDirection: [
      [/(?:false|true|null)/, { token: 'boolean', next: '@pop' }],
    ],
    inKeywordReference: [
      [/"(?:[^"\\]|\\.)*"/, { token: 'reference', next: '@pop' }],
    ],
    inKeywordInherit: [[/"[-+=]"/, { token: 'enum', next: '@pop' }]],
    inSubqueries: [
      [/{/, { token: 'delimiter.bracer', switchTo: 'inSubqueriesBody' }],
    ],
    inSubqueriesBody: [
      [/"(?:[^"\\]|\\.)*":/, { token: 'reference' }],
      [/{/, { token: 'delimiter.bracer', next: 'keywords' }],
      [/}/, { token: 'delimiter.bracer', next: '@pop' }],
    ],
    inVariables: [
      [/{/, { token: 'delimiter.bracer', switchTo: 'inVariablesBody' }],
    ],
    inVariablesBody: [
      [/"(?:[^"\\]|\\.)*":/, { token: 'reference' }],
      [/"(?:[^"\\]|\\.)*"/, { token: 'string' }],
      [/}/, { token: 'delimiter.bracer', next: '@pop' }],
    ],
    inRef: [[/{/, { token: 'delimiter.bracer', switchTo: 'inRefBody' }]],
    inRefBody: [
      [/"attr":\s/, { token: 'keyword', next: 'inKeywordReference' }],
      [/"inherit":\s/, { token: 'keyword', next: 'inKeywordInherit' }],
      [/}/, { token: 'delimiter.bracer', next: '@pop' }],
    ],
    inExpression: [
      [/{/, { token: 'delimiter.bracer', switchTo: 'inFunction' }],
      // all strings
      [/"(?:[^"\\]|\\.)*"/, { token: 'string', next: '@pop' }],
      // TODO: support negative numbers
      // all digits
      [/\d+/, { token: 'number', next: '@pop' }],
      // Boolean & null
      [/(?:false|true|null)/, { token: 'boolean', next: '@pop' }],
    ],
    inFunction: [
      // TODO: find a way to enable this, if we do everything according to linter, it won't work as expected
      /* eslint-disable no-useless-escape */
      [/"(?:|@|@\$)":\s*/, { token: 'function-key', switchTo: 'inLookup' }],
      [/"@\.":\s*/, { token: 'function-key', switchTo: 'inGetAttribute' }],
      [/"@\^":\s*/, { token: 'function-key', switchTo: 'inGetAncestorId' }],
      [/"(?:@\.\*)":\s*/, { token: 'function-key', switchTo: 'inGetRecord' }],
      [/"@>":\s*/, { token: 'function-key', switchTo: 'inGetProperty' }],
      [/"@\_":\s*/, { token: 'function-key', switchTo: 'inGetModelInfo' }],
      [/"{}":/, { token: 'function-key', switchTo: 'inBuildObject' }],
      [/"\[\]":/, { token: 'function-key', switchTo: 'inCreateTuple' }],
      [/"{}\>\[\]":/, { token: 'function-key', switchTo: 'inObjectToList' }],
      [/"\[\]\>{}":/, { token: 'function-key', switchTo: 'inListToObject' }],
      [/"->":/, { token: 'function-key', switchTo: 'inMap' }],
      [/"\+\+":/, { token: 'function-key', switchTo: 'inConcatenate' }],
      [/"uniq":/, { token: 'function-key', switchTo: 'inUniq' }],
      [/"\+":\s*/, { token: 'function-key', switchTo: 'inAdd' }],
      [/"\-":\s*/, { token: 'function-key', switchTo: 'inSubtract' }],
      [/"\*":\s*/, { token: 'function-key', switchTo: 'inMultiply' }],
      // "/" "%" "^"
      [/"(?:\/|\%|\^)":\s*/, { token: 'function-key', switchTo: 'inMathArgs' }],
      [/"not":\s*/, { token: 'function-key', switchTo: 'inNot' }],
      [
        /"(?:and|or)":\s*/,
        { token: 'function-key', switchTo: 'inLogicalSimple' },
      ],
      [
        /"(?:some|every)":\s*/,
        { token: 'function-key', switchTo: 'inLogicalComplex' },
      ],
      [/"if":\s*/, { token: 'function-key', switchTo: 'inIf' }],
      [/"\?\?":\s*/, { token: 'function-key', switchTo: 'inCoalesce' }],
      [
        /"(?:in|\=|\!\=|\>|\>\=|\<|\<\=)":\s*/,
        { token: 'function-key', switchTo: 'inComparison' },
      ],
      [/"\#":\s*/, { token: 'function-key', switchTo: 'inCount' }],
      [/"fmt.num":\s*/, { token: 'function-key', switchTo: 'inFormatNumber' }],
      [/"`":\s*/, { token: 'function-key', switchTo: 'inInject' }],
      [/"similarity":\s*/, { token: 'function-key', switchTo: 'inSimilarity' }],
      [/"isSimilar":\s*/, { token: 'function-key', switchTo: 'inIsSimilar' }],
      /* eslint-enable no-useless-escape */
    ],
    inBuildObject: [
      [/{/, { token: 'delimiter.bracer', next: 'inBuildObjectBody' }],
      [/}/, { token: 'delimiter.bracer', next: '@pop' }],
    ],
    inBuildObjectBody: [
      [/"(?:[^"\\]|\\.)*":/, { token: 'object-key', next: 'inExpression' }],
      [/}/, { token: 'delimiter.bracer', next: '@pop' }],
    ],
    inLookup: [
      [/"(?:[^"\\]|\\.)*"/, { token: 'reference' }],
      [/}/, { token: 'delimiter.bracer', next: '@pop' }],
    ],

    inGetAttribute: [
      // handles the standard case {"@.": "!attribute"}
      [/"(?:[^"\\]|\\.)*"/, { token: 'reference' }],
      // Enters more advance case {"@.": "!attribute"}
      [
        /\[/,
        {
          token: 'delimiter.bracer',
          switchTo: 'inGetAttributeFirstArg',
        },
      ],
      [/}/, { token: 'delimiter.bracer', next: '@pop' }],
    ],
    inGetAttributeFirstArg: [
      [/"(?:[^"\\]|\\.)*"/, { token: 'reference' }],
      [/,/, { token: 'delimiter', next: 'inGetAttributeSecondArg' }],
      [/}/, { token: 'delimiter.bracer', next: '@pop' }],
    ],
    inGetAttributeSecondArg: [
      [/]/, { token: 'delimiter.bracer', next: '@pop' }],
      [
        /{/,
        {
          token: 'delimiter.bracer',
          next: 'inGetAttributeSecondArgBody',
        },
      ],
    ],
    inGetAttributeSecondArgBody: [
      [/"ref":/, { token: 'keyword' }],
      [
        /{/,
        {
          token: 'delimiter.bracer',
          next: 'inGetAttributeSecondArgBodyRefBody',
        },
      ],
      [/}/, { token: 'delimiter.bracer', next: '@pop' }],
    ],
    inGetAttributeSecondArgBodyRefBody: [
      [/"(?:entityIdFormat|entity|format)":\s*/, { token: 'keyword' }],
      // TODO: "entityIdFormat", "entity", and "format" properties need to validate their values
      // against their keys. Currently values can be mismatched with keys, e.g.
      // {"entityId": "partial"} would pass validation but is invalid.
      [/"(full|partial|dim|ent|ent-id|record-id)"/, { token: 'enum' }],
      [/"(?:[^"\\]|\\.)*"/, { token: 'reference' }],
      [/}/, { token: 'delimiter.bracer', next: '@pop' }],
    ],

    inGetAncestorId: [
      [/"(parent|root|object)"/, { token: 'enum' }],
      [/"(?:[^"\\]|\\.)*"/, { token: 'reference' }],
      [/\[/, { token: 'delimiter.bracer', next: '@inGetAncestorList' }],
      [/}/, { token: 'delimiter.bracer', next: '@pop' }],
    ],
    inGetAncestorList: [
      [/"(?:list|object)"/, { token: 'enum' }],
      [/{/, { token: 'delimiter.bracer', next: 'inGetAncestorListParams' }],
      [/]/, { token: 'delimiter.bracer', next: '@pop' }],
    ],
    inGetAncestorListParams: [
      // TODO: find a way to enable this, if we do everything according to linter, it won't work as expected
      /* eslint-disable no-useless-escape */
      [/\"entityIdFormat"\s*:/, { token: 'keyword' }],
      [/"(?:full|partial)"/, { token: 'enum' }],
      [/}/, { token: 'delimiter.bracer', next: '@pop' }],
      /* eslint-enable no-useless-escape */
    ],
    inGetRecord: [
      [/{}/, 'delimiter.bracket'],
      [/{/, { token: 'delimiter.bracket', next: 'inGetRecordParams' }],
      [/}/, { token: 'delimiter.bracer', next: '@pop' }],
    ],
    inGetRecordParams: [
      // TODO: find a way to enable this, if we do everything according to linter, it won't work as expected
      /* eslint-disable no-useless-escape */
      [/\"attributeIdFormat"\s*:/, { token: 'keyword' }],
      [/"(?:full|partial)"/, { token: 'enum' }],
      [/}/, { token: 'delimiter.bracer', next: '@pop' }],
      /* eslint-enable no-useless-escape */
    ],
    // "@>"
    inGetProperty: [
      [/\[/, { token: 'delimiter.bracer', next: 'inGetPropertyFirstArg' }],
      [/}/, { token: 'delimiter.bracer', next: '@pop' }],
      // Handles direct property lookup expressions like {"@>": expression}
      // Used for static field access within the nearest CreateObject or CreateTuple
      [/[^\s]/, { token: 'invalid', next: 'inExpression', goBack: 1 }],
    ],
    inGetPropertyFirstArg: [
      [/,/, { token: 'delimiter', switchTo: 'inGetPropertyFirstSecond' }],
      [/[^\s]/, { token: 'invalid', next: 'inExpression', goBack: 1 }],
    ],
    inGetPropertyFirstSecond: [
      [/]/, { token: 'delimiter.bracer', next: '@pop' }],
      [/[^\s]/, { token: 'invalid', next: 'inExpression', goBack: 1 }],
    ],
    // "@_"
    inGetModelInfo: [
      [
        /"(?:description|id|level|name|note|parent|child|root|leaf)"/,
        { token: 'enum' },
      ],
      [/}/, { token: 'delimiter.bracer', next: '@pop' }],
      [/\[/, { token: 'delimiter.bracer', next: 'inGetModelInfoArray' }],
    ],
    inGetModelInfoArray: [
      { include: 'inGetModelInfo' },
      [/"(?:[^"\\]|\\.)*"/, { token: 'reference' }],
      [/\]/, { token: 'delimiter.bracer', next: '@pop' }],
    ],
    // "[]"
    inCreateTuple: [
      [/}/, { token: 'delimiter.bracer', next: '@pop' }],
      [/\[/, { token: 'delimiter.bracer', next: 'inCreateTupleBody' }],
    ],
    inCreateTupleBody: [
      [/\]/, { token: 'delimiter.bracer', next: '@pop' }],
      [/[^\s]/, { token: 'invalid', next: 'inExpression', goBack: 1 }],
    ],
    // "{}>[]"
    inObjectToList: [
      [/\[/, { token: 'delimiter.bracer', next: 'inObjectToListFirstArg' }],
      [/}/, { token: 'delimiter.bracer', next: '@pop' }],
      [/[^\s]/, { token: 'invalid', next: 'inExpression', goBack: 1 }],
    ],
    inObjectToListFirstArg: [
      [/,/, { token: 'delimiter', switchTo: 'inObjectToListSecondArg' }],
      [/[^\s]/, { token: 'invalid', next: 'inExpression', goBack: 1 }],
    ],
    inObjectToListSecondArg: [
      [/,/, { token: 'delimiter', switchTo: 'inObjectToListThirdArg' }],
      [/"(?:[^"\\]|\\.)*"/, { token: 'string' }],
    ],
    inObjectToListThirdArg: [
      [/"(?:[^"\\]|\\.)*"/, { token: 'string' }],
      [/\]/, { token: 'delimiter.bracer', next: '@pop' }],
    ],
    // "[]>{}"
    inListToObject: [
      [/\[/, { token: 'delimiter.bracer', next: 'inListToObjectFirstArg' }],
      [/}/, { token: 'delimiter.bracer', next: '@pop' }],
      [/[^\s]/, { token: 'invalid', next: 'inExpression', goBack: 1 }],
    ],
    inListToObjectFirstArg: [
      [/,/, { token: 'delimiter', switchTo: 'inListToObjectSecondArg' }],
      [/[^\s]/, { token: 'invalid', next: 'inExpression', goBack: 1 }],
    ],
    inListToObjectSecondArg: [
      [/,/, { token: 'delimiter', switchTo: 'inListToObjectThirdArg' }],
      [/"(?:[^"\\]|\\.)*"/, { token: 'string' }],
    ],
    inListToObjectThirdArg: [
      [/"(?:[^"\\]|\\.)*"/, { token: 'string' }],
      [/\]/, { token: 'delimiter.bracer', next: '@pop' }],
    ],
    // "-> "
    inMap: [
      [/\[/, { token: 'delimiter.bracer', next: 'inMapFirstArg' }],
      [/}/, { token: 'delimiter.bracer', next: '@pop' }],
    ],
    inMapFirstArg: [
      [/,/, { token: 'delimiter', switchTo: 'inMapSecondArg' }],
      [/[^\s]/, { token: 'invalid', next: 'inExpression', goBack: 1 }],
    ],
    inMapSecondArg: [
      [/\]/, { token: 'delimiter.bracer', next: '@pop' }],
      [/[^\s]/, { token: 'invalid', next: 'inExpression', goBack: 1 }],
    ],
    // "++"
    inConcatenate: [
      [/\[/, { token: 'delimiter.bracer', next: 'inConcatenateBody' }],
      [/}/, { token: 'delimiter.bracer', next: '@pop' }],
    ],
    inConcatenateBody: [
      [/\]/, { token: 'delimiter.bracer', next: '@pop' }],
      [/[^\s]/, { token: 'invalid', next: 'inExpression', goBack: 1 }],
    ],
    // "uniq"
    inUniq: [
      [/}/, { token: 'delimiter.bracer', next: '@pop' }],
      [/[^\s]/, { token: 'invalid', next: 'inExpression', goBack: 1 }],
    ],
    inNot: [
      [/}/, { token: 'delimiter.bracer', next: '@pop' }],
      [/[^\s]/, { token: 'invalid', next: 'inExpression', goBack: 1 }],
    ],
    inInject: [
      [/{/, { token: 'delimiter.bracer', next: 'inInjectPossibleDeInject' }],
      [/}/, { token: 'delimiter.bracer', next: '@pop' }],
      [/./, 'string'],
    ],
    inInjectPossibleDeInject: [
      [/"``":\s*/, { token: 'function-key', next: 'inExpression' }],
      { include: 'inInject' },
    ],
    // "+"
    inAdd: [
      [/\[/, { token: 'delimiter.bracer', next: 'inAddBody' }],
      [/}/, { token: 'delimiter.bracer', next: '@pop' }],
      [/[^\s]/, { token: 'invalid', next: 'inExpression', goBack: 1 }],
    ],
    inAddBody: [
      [/\]/, { token: 'delimiter.bracer', next: '@pop' }],
      [/[^\s]/, { token: 'invalid', next: 'inExpression', goBack: 1 }],
    ],
    // "-"
    inSubtract: [
      [/\[/, { token: 'delimiter.bracer', next: 'inSubtractBody' }],
      [/}/, { token: 'delimiter.bracer', next: '@pop' }],
    ],
    inSubtractBody: [
      [/\]/, { token: 'delimiter.bracer', next: '@pop' }],
      [/[^\s]/, { token: 'invalid', next: 'inExpression', goBack: 1 }],
    ],
    // "*"
    inMultiply: [
      [/\[/, { token: 'delimiter.bracer', next: 'inMultiplyBody' }],
      [/}/, { token: 'delimiter.bracer', next: '@pop' }],
      [/[^\s]/, { token: 'invalid', next: 'inExpression', goBack: 1 }],
    ],
    inMultiplyBody: [
      [/\]/, { token: 'delimiter.bracer', next: '@pop' }],
      [/[^\s]/, { token: 'invalid', next: 'inExpression', goBack: 1 }],
    ],
    // "/" "%" "^"
    inMathArgs: [
      [/\[/, { token: 'delimiter.bracer', next: 'inMathArgsFirst' }],
      [/}/, { token: 'delimiter.bracer', next: '@pop' }],
    ],
    inMathArgsFirst: [
      [/,/, { token: 'delimiter', switchTo: 'inMathArgsSecond' }],
      [/[^\s]/, { token: 'invalid', next: 'inExpression', goBack: 1 }],
    ],
    inMathArgsSecond: [
      [/\]/, { token: 'delimiter.bracer', next: '@pop' }],
      [/[^\s]/, { token: 'invalid', next: 'inExpression', goBack: 1 }],
    ],
    // "and/or"
    inLogicalSimple: [
      [/\[/, { token: 'delimiter.bracer', next: 'inLogicalSimpleBody' }],
      [/}/, { token: 'delimiter.bracer', next: '@pop' }],
    ],
    inLogicalSimpleBody: [
      [/\]/, { token: 'delimiter.bracer', next: '@pop' }],
      [/[^\s]/, { token: 'invalid', next: 'inExpression', goBack: 1 }],
    ],
    // "some/every"
    inLogicalComplex: [
      [/\[/, { token: 'delimiter.bracer', next: 'inLogicalComplexFirstArg' }],
      [/\}/, { token: 'delimiter.bracer', next: '@pop' }],
      [/[^\s]/, { token: 'invalid', next: 'inExpression', goBack: 1 }],
    ],
    inLogicalComplexFirstArg: [
      [/,/, { token: 'delimiter', switchTo: 'inLogicalComplexSecondArg' }],
      [/[^\s]/, { token: 'invalid', next: 'inExpression', goBack: 1 }],
    ],
    inLogicalComplexSecondArg: [
      [/\]/, { token: 'delimiter.bracer', next: '@pop' }],
      [/[^\s]/, { token: 'invalid', next: 'inExpression', goBack: 1 }],
    ],
    // "if"
    inIf: [
      [/\[/, { token: 'delimiter.bracer', next: 'inIfBody' }],
      [/}/, { token: 'delimiter.bracer', next: '@pop' }],
    ],
    inIfBody: [
      [/\[/, { token: 'delimiter.bracer', next: 'inIfBodyCase' }],
      [/\]/, { token: 'delimiter.bracer', next: '@pop' }],
      // else
      [/{/, { token: 'delimiter.bracer', next: 'inFunction' }],
      { include: 'primitives' },
    ],
    inIfBodyCase: [
      [/\]/, { token: 'delimiter.bracer', next: '@pop' }],
      [/[^\s]/, { token: 'invalid', next: 'inExpression', goBack: 1 }],
    ],
    // "??"
    inCoalesce: [
      [/\[/, { token: 'delimiter.bracer', next: 'inCoalesceBody' }],
      [/}/, { token: 'delimiter.bracer', next: '@pop' }],
    ],
    inCoalesceBody: [
      [/\]/, { token: 'delimiter.bracer', next: '@pop' }],
      [/[^\s]/, { token: 'invalid', next: 'inExpression', goBack: 1 }],
    ],
    // "in"  "="
    inComparison: [
      [/\[/, { token: 'delimiter.bracer', next: 'inComparisonBody' }],
      [/}/, { token: 'delimiter.bracer', next: '@pop' }],
    ],
    inComparisonBody: [
      [/\]/, { token: 'delimiter.bracer', next: '@pop' }],
      [/[^\s]/, { token: 'invalid', next: 'inExpression', goBack: 1 }],
    ],
    inCount: [
      [/}/, { token: 'delimiter.bracer', next: '@pop' }],
      [/[^\s]/, { token: 'invalid', next: 'inExpression', goBack: 1 }],
    ],

    inFormatNumber: [
      { include: 'inExpression' },
      [/\[/, { token: 'delimiter.bracer', next: 'inFormatNumberFirstArg' }],
      [/}/, { token: 'delimiter.bracer', next: '@pop' }],
    ],
    inFormatNumberFirstArg: [
      [/,/, { token: 'delimiter', switchTo: 'inFormatNumberSecondArg' }],
      [/]/, { token: 'delimiter.bracer', next: '@pop' }],
      [/[^\s]/, { token: 'invalid', next: 'inExpression', goBack: 1 }],
    ],
    inFormatNumberSecondArg: [
      [/"(?:\$|%|#|#.)"/, { token: 'enum' }],
      // TODO: Finish implementing
      // [/{/, {token: 'delimiter.bracer.1', next: "inFormatNumberOptions"}],
      [/]/, { token: 'delimiter.bracer', next: '@pop' }],
    ],
    // TODO: Finish implementing
    inFormatNumberOptions: [
      // [/"(?:|,|scalar|suffix)":\s/, {token: 'keyword'}],
      // [/"\.":\s/, {token: 'keyword', next: 'inFormatNumberPeriodOptions'}],
      // {include: 'primitives'},
    ],
    // TODO: Finish implementing
    inFormatNumberPeriodOptions: [
      // [/{/, {token: "delimiter.bracer.2",  next: "inFormatNumberPeriodOptionsBody"}],
    ],
    // TODO: Finish implementing
    inFormatNumberPeriodOptionsBody: [
      // [/}/, {token: 'delimiter.bracer.3', next: "@pop"}]
    ],
    inSimilarity: [
      [/\[/, { token: 'delimiter.bracer', next: 'inSimilarityBody' }],
      [/}/, { token: 'delimiter.bracer', next: '@pop' }],
    ],
    inSimilarityBody: [
      [/\]/, { token: 'delimiter.bracer', next: '@pop' }],
      [/[^\s]/, { token: 'invalid', next: 'inExpression', goBack: 1 }],
    ],
    inIsSimilar: [
      [/\[/, { token: 'delimiter.bracer', next: 'inIsSimilarBody' }],
      [/\{/, { token: 'delimiter.bracer', next: 'inIsSimilarBodyFirstArg' }],
      [/}/, { token: 'delimiter.bracer', next: '@pop' }],
    ],
    inIsSimilarBody: [
      [/\]/, { token: 'delimiter.bracer', next: '@pop' }],
      [/[^\s]/, { token: 'invalid', next: 'inExpression', goBack: 1 }],
    ],
    inIsSimilarBodyFirstArg: [
      [/"threshold":/, { token: 'keyword', next: 'inExpression' }],
      [/,/, { token: 'delimiter', switchTo: 'inIsSimilarBodySecondArg' }],
    ],
    inIsSimilarBodySecondArg: [
      [/"expressions":/, { token: 'keyword' }],
      [
        /\[/,
        { token: 'delimiter.bracer', next: 'inIsSimilarBodySecondArgBody' },
      ],
      [/}/, { token: 'delimiter.bracer', next: '@pop' }],
    ],
    inIsSimilarBodySecondArgBody: [
      [/\]/, { token: 'delimiter.bracer', next: '@pop' }],
      [/[^\s]/, { token: 'invalid', next: 'inExpression', goBack: 1 }],
    ],

    primitives: [
      [/"(?:[^"\\]|\\.)*"/, { token: 'string' }],
      [/\d+/, { token: 'number' }],
      [/(?:false|true|null)/, { token: 'boolean' }],
    ],
  },
}
export const CONFIG: monaco.languages.LanguageConfiguration = {
  // Do not colorize bracket pairs
  colorizedBracketPairs: [],
  brackets: [
    ['{', '}'],
    ['[', ']'],
  ],
}
/* eslint-enable sort-keys */

export const DOCUMENT_FORMATTING_EDIT_PROVIDER: monaco.languages.DocumentFormattingEditProvider =
  {
    provideDocumentFormattingEdits: (model, options, token) => {
      try {
        const json = JSON.parse(model.getValue())
        const formattedJson = JSON.stringify(json, null, options.tabSize)
        return [
          {
            range: model.getFullModelRange(),
            text: formattedJson,
          },
        ]
      } catch (err) {
        return []
      }
    },
  }
